<template>
    <ul class="rowView">
        <div v-for="user in users" :key="user.name" style="display: flex; flex-direction: column; align-items: center; margin-right: 20px;">
            <li class="highlighter">
                <div class="highlighter__container">
                    <!-- <div class="highlighter__container__name">
                    {{ user.fullname }}
                </div> -->
                    <div class="highlighter__container__image">
                        <img :src="user.avatar" alt="User Image" />
                    </div>
                </div>
            </li>
            <div class="">
                {{ user.username }}
            </div>
        </div>
    </ul>
</template>

<script>
import axios from 'axios';
import { Apis } from '../../constants';

export default {
    components: {
    },
    mounted() {
        axios.get(Apis.get_top_users, {
            withCredentials: true
        }).then(response => {
            this.users = response.data;
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            this.$loading.hide();
        });
    },
    data() {
        return {
            users: [
            ]
        }
    },
    methods: {
    }
}
</script>

<style>
.rowView {
    display: flex;
    flex-direction: row;
    padding: 0;
    padding-bottom: 10px;
    overflow-x: scroll;
}

.rowView::-webkit-scrollbar {
    height: 5px;
}

.highlighter {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    background-color: #FFFFFF;
    aspect-ratio: 1 / 1;
    min-width: 80px;
    width: 100px;
    height: 100px;
    overflow: hidden;


    /* circular rainbow border */
    border-radius: 50%;
    border: 10px solid;
    border-width: 2px;
    border-color: #dfdfdf;


    .highlighter__container {
        display: flex;
        flex-direction: column;

        .highlighter__container__image {
            border-radius: 50%;
            overflow: hidden;
            margin-bottom: 5px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
}
</style>
